export default __webpack_public_path__ + "static/media/mobilecover.88306aab.svg";